export default "__VITE_ASSET__CHTYQsU$__"